export default __webpack_public_path__ + "f2c40720019e2481c3cc7b04ee072a6f.otf";